import { z } from 'zod';

export const OrganizationMemberRoleSchema = z.enum([ 'owner', 'member' ]);
export type OrganizationMemberRole = z.infer<typeof OrganizationMemberRoleSchema>;